import React from "react";
import { Link } from "gatsby";
import Grid from "../Grid/Grid";
import GridItem from "../GridItem/GridItem";

import authorDetails from "../../utils/authorName";
import Image from "../Image/Image";
import "./PostHeader.css";

const PostHeader = ({
  title,
  date,
  author,
  categories,
  wordCount,
  imageData,
}) => {
  const wordCountSuffix = wordCount == 1 ? " word" : " words";

  return (
    // TODO (Milestone > 2): make classes configurable so headers are themable
    <>
      <header className="coop-c-postheader coop-u-text-bg coop-u-white coop-u-padding-t-64 coop-u-padding-b-64">
        <div className="coop-l-container">
          <Grid center>
            <GridItem lg={8}>
              <nav className="coop-c-breadcrumbs" aria-label="Breadcrumb">
                <ul className="coop-u-list-bare coop-u-list-inline">
                  <li>
                    <Link to="/" className="coop-c-breadcrumbs__link">
                      Blog
                    </Link>
                  </li>
                </ul>
              </nav>
              <h1 className="coop-c-postheader__title">{title}</h1>
              <p className="coop-c-postheader__info coop-t-h4">
                <span className="coop-c-postheader__date">{date}</span>
                <span>
                  {wordCount}
                  {wordCountSuffix}
                </span>
              </p>
              {/* Authors */}
              {author.authorName && (
                <p className="coop-u-margin-b-0">
                  Written by {authorDetails(author)}
                </p>
              )}
            </GridItem>
          </Grid>
        </div>
      </header>
      {imageData && (
        <div className="coop-l-section coop-l-section--theme-dotted">
          <div className="coop-l-container">
            <Grid center>
              <GridItem>
                <Image
                  imageSrc={imageData.imageChildSharp.gatsbyImageData}
                  altText={imageData.altText}
                />
              </GridItem>
            </Grid>
          </div>
        </div>
      )}
    </>
  );
};

export default PostHeader;
